import React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useLocation, useNavigate } from "react-router-dom";
import {
    ADMIN_AD_SOCIAL_FACEBOOK_PATH,
    ADMIN_AD_SOCIAL_INSTAGRAM_PATH,
    ADMIN_AD_SOCIAL_WORD_WHEEL_GRID_PATH,
    ADMIN_AD_SOCIAL_WORD_WHEEL_PATH,
} from "../advertisementRoutes";

function tabFromPath(pathname) {
    if (typeof pathname !== "string") return ADMIN_AD_SOCIAL_FACEBOOK_PATH;
    if (pathname.includes("/instagram")) return ADMIN_AD_SOCIAL_INSTAGRAM_PATH;
    if (pathname.includes("/word-wheel-grid")) return ADMIN_AD_SOCIAL_WORD_WHEEL_GRID_PATH;
    if (pathname.includes("/word-wheel")) return ADMIN_AD_SOCIAL_WORD_WHEEL_PATH;
    return ADMIN_AD_SOCIAL_FACEBOOK_PATH;
}

export default function SocialTabs() {
    const location = useLocation();
    const navigate = useNavigate();
    const value = tabFromPath(location.pathname);

    return (
        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
            <Tabs
                value={value}
                onChange={(_, path) => navigate(path)}
                variant="scrollable"
                allowScrollButtonsMobile
            >
                <Tab label="Facebook" value={ADMIN_AD_SOCIAL_FACEBOOK_PATH} />
                <Tab label="Instagram" value={ADMIN_AD_SOCIAL_INSTAGRAM_PATH} />
                <Tab label="Word Wheel" value={ADMIN_AD_SOCIAL_WORD_WHEEL_PATH} />
                <Tab label="Word Wheel (Grid)" value={ADMIN_AD_SOCIAL_WORD_WHEEL_GRID_PATH} />
            </Tabs>
        </Box>
    );
}
